import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localeSort'
})
export class LocaleSortPipe implements PipeTransform {

  transform(items: any, field: string): Array<any> {
    const lang = $localize.locale.split('-')[0]

    return items.sort((a: any, b: any) => {
      const aValue = a[field + '_' + lang] || a[field];
      const bValue = b[field + '_' + lang] || b[field];
      
      return aValue.localeCompare(bValue, lang);
    });
  }
}
